<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19GrNTd/tc-custom/9781488018831.jpg?1720280500229" alt="This image is the cover for the book Mountain Ambush, Echo Mountain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mountain Ambush, Echo Mountain
      </h1>
      <p class="bookDescription body article font2">
        <b>In the Pacific Northwest, a doctor is being targeted for death—and with a beautiful EMT at his side, he must find out why . . . </b><br/><br/>A search-and-rescue mission turns deadly when Dr. Kyle Spencer is nearly killed by an assailant in the mountains. And when EMT Maddie McBride saves the doctor just in time, they’re both targeted—but no one knows why. One thing’s clear, though—from the moment Maddie finds Echo Mountain’s most eligible bachelor left for dead, she can’t stop thinking about him.<br/><br/>But she’s always been wary of the town’s Dr. Dreamboat. And Spence’s scarred heart’s been shuttered since a childhood tragedy. As someone stalks the injured doctor’s every move, though, Spence realizes that he needs the determined Maddie in his corner. However, he can’t be sure their partnership will be enough to save them . . . especially against a seemingly all-knowing foe who’s got them both in his deadly sights.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hope White
      </h2>
      
      <p class="authorDescription body article">With a degree in journalism, Hope White started her writing career as a reporter but found she wanted to do more than report the facts &ndash; she wanted to give readers a happy ending. Now she&rsquo;s thrilled to be combining mystery, adventure and romance for Love Inspired Suspense. When not at her computer, you&rsquo;ll find Hope hiking in the Cascade Mountains or enjoying a cup of tea with friends. You can find her at: www.hopewhiteauthor.com or facebook.com/hopewhiteauthor</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e4a0fc0